<template>
  <div id="app">
    <headers class="header-container"></headers>
    <router-view></router-view>
    <footers></footers>
  </div>
</template>
<script>
import footers from '../src/components/footer.vue'
import headers from '../src/components/header.vue'

export default {
  components: {
    footers,
    headers
  },
  data () {
    return {
      carouselHeight: 0,
      footerShow: false,
      footerTab: '0',
    }
  },
  created () {
    this.carouselHeight = (document.body.clientWidth * 0.7 * 0.5) / (761 / 400);
  },
  mounted () {
    // window.onresize = () => {
    //   return (() => {
        this.bodyScale();
    //   })();
    // };
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('tokens')
      localStorage.removeItem('userInfo')
    })
  },
  methods: {
    bodyScale() {
      let devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
      let scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.body.style.zoom = scale; //放大缩小相应倍数
    },
    footer (val) {
      this.footerShow = val[0]
      this.footerTab = val[1]
    },
  },

  name: 'App',
}
</script>

<style>
@media screen and (max-width: 600px) {

  .footer{
    width: 100% !important;
  }

}
html,
body,
#app {
  height: 100%;
}
.top{
  margin-top: 90px;
}

#app {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #444;
}

* {
  padding: 0;
  border: 0;
  outline: none;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ul,
ol,
li,
pre,
i,
form,
fieldset,
legend,
button,
input,
textarea,
th,
td {
  margin: 0;
  padding: 0;
  color: #424242;
}

body {
  background: #ffffff;
}

.header-container{
}

textarea {
  resize: none;
}

a {
  text-decoration: none;
  cursor: pointer;
  color: #444;
}

a:focus {
  outline: none;
}

a:hover,
a:active {
  outline: none;
  text-decoration: none;
}

ul,
dl,
dd,
dt,
li,
form,
h3,
h2,
h1,
form {
  margin: 0;
  padding: 0;
}

ul {
  list-style: none;
}

h1,
h2,
h3,
h4 {
  font-weight: 100;
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/App.vue